import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

interface EntryActionsProps {
  /** Seek the video to this entry's start. */
  onJump: () => void;
  onDelete: () => void;
  disabled?: boolean;
}

/** Per-entry controls: jump-to-time and delete. */
export const EntryActions: React.FC<EntryActionsProps> = ({
  onJump,
  onDelete,
  disabled = false,
}) => (
  <Box display="flex" alignItems="center" gap={0.5}>
    <Tooltip title="Play from here">
      <IconButton size="small" onClick={onJump}>
        <PlayCircleOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
    <Tooltip title="Delete entry">
      <span>
        <IconButton
          size="small"
          color="error"
          onClick={onDelete}
          disabled={disabled}
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  </Box>
);
